import _ from 'es-toolkit/compat';

import type { BulkUploadExtendedEntity } from 'src/types/bulkUpload';

export const clearEntitiesData = <T>(
  entities: BulkUploadExtendedEntity<T>[],
): Omit<BulkUploadExtendedEntity<T>, 'id' | 'valid'>[] => {
  return entities.map(entity => _.omit(entity, ['id', 'valid']));
};
